module.exports = __webpack_public_path__ + "media/applicants/login-icon-ba97bb12.svg";